<template>
  <div class="step-container scrollPosition haus-step-4">
    <div class="step-header">
      <h2 class="step-title">Zustand</h2>
      <p class="step-text">In welchem Zustand befindet sich das Haus?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Sehr gut /<br/> neuwertig"
          @click="setZustand(10)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8399.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8399_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Gut /<br/> normale Instandhaltung"
          @click="setZustand(40)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8398.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8398_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Mäßig /<br/> Instandhaltungen notwendig"
          @click="setZustand(60)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8553.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8553_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50 box-item-large"
          text="Schwach /<br/> umfassende Instandhaltung notwendig"
          @click="setZustand(80)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8835.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8835_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Constants from "@/constants.js";

import ActionBox from "@/components/shared/ActionBox.vue";
import { saveToStorage, getFieldFromStorage } from "@/utils.js";
export default {
  name: "haus-step-6",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexHausErhaltung: { value: null },
      },
    };
  },
  methods: {
    setZustand(index) {
      this.fields.indexHausErhaltung.value = index;
      saveToStorage(this.fields);
      this.$router.push("/haus-step-7");
    },
    goBack() {
      saveToStorage(this.fields);
      const ageOfProperty =
        new Date().getFullYear() - getFieldFromStorage("hausBaujahr");
      if (ageOfProperty >= Constants.NEW_BUILDING_THRESHOLD) {
        this.$router.push("/haus-step-5");
      } else {
        this.$router.push("/haus-step-4");
      }
          // this.$router.push("/haus-step-4");

    },
  },
  mounted() {
    this.$emit("setStep", "haus", 7);
  },
};
</script>
